export default __webpack_public_path__ + "static/media/notfourme.ac78fc19.png";